import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface HosIntranetKeyFeaturesProps {
    hospitalIntranetData: any
}

const HosIntranetKeyFeatures: FC<HosIntranetKeyFeaturesProps> = ({ hospitalIntranetData }) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 p-6 md:p-20 bg-darkGreyPrimary'>
            {hospitalIntranetData.HosIntraFeatureList.map((reliable: any, index: number) => {
                return (
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0, borderRadius: '30px' ,borderTopColor: `${reliable.bgColor}`}}
                        viewport={{ once: false }}
                        className='mb-4 md:mb-0 group rounded-2xl' 
                        key={index}
                        whileHover={{
                            borderTopWidth: '4px',
                            borderTopStyle: 'solid',
                            borderTopColor: `${reliable.bgColor}`,
                            borderRadius: '30px',
                            scale: 1.05,
                            transition: { duration: 0.5, ease: "easeOut" }
                        }}
                    >
                        <div className={`group`}>
                            <div className="flex flex-col items-start justify-center p-4 md:px-8 bg-blackDark rounded-2xl relative">
                                <div className='rounded-2xl w-full'>
                                    <div className={`text-xl md:text-2xl text-start font-bold text-white`}>{index + 1}.</div>
                                    <div className={`text-lg md:text-xl text-start font-semibold text-white mb-3 group-hover:text-${reliable.color}`}>{reliable.title}</div>
                                    <ul className='list-disc flex flex-col gap-2 md:gap-3 pl-5'>
                                        {reliable.list.map((item: any) => {
                                            return (
                                                <li>
                                                    <div className='text-white text-start text-sm md:text-md pr-4 md:pr-8 font-bold'>{item.title}</div>
                                                    <div className='text-white text-start text-xs md:text-sm pr-4 md:pr-8'> {item.subtitle}</div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                )
            })}
        </div>
    )
}

export default HosIntranetKeyFeatures
